import EventEmitter from 'events';

/**
 * Emitted when a Module resolve from Module.init(). All sub-modules are required to emit this event.
 * @event Module#init
 * 
 */

/**
 * A Module privodes a scope for controller logic within a page. Inspired by the Revealing Pattern
 * 
 * @class Module
 * @extends {EventEmitter}
 * @property {boolean} initialized Indicates if the module has been initialized, ie. the module emitted the `init` event
 */
class Module extends EventEmitter {

	/**
     * Creates an instance of Module.
     * @param {object} [options={}] 
     * @memberof Module
     */
	constructor(options) {
		super();
		this._options = Object.assign({}, options);

		this.initialized = false;
	}

	/**
     * Bind events to the module. These could be DOM events, service events, or module events, etc. Should be overriden by sub-classes.
     * 
	 * @override
     * @memberof Module
	 * @listens Module#init
     */
	bindEvents() { }

	_bindEvents() {
		this.on('init', e => {
			this.initialized = true;
			this.main();
		});
	}

	/**
     * Initializes the module. Any sub-module must override this method to emit an `init` event
     * 
     * @returns {Promise.<void>} A promise that resolves when initialization is finished
     * @memberof Module
     */
	init() {
		return new Promise(resolve => {

			this._bindEvents();
			this.bindEvents();

			// other work

			return resolve();
		})
	}

	/**
	 * Called when the `init` event is emitted. Should be overriden by sub-classes.
	 * 
	 * @override
	 * @memberof Module
	 */
	main() { }
}

export default Module


// WEBPACK FOOTER //
// ./wwwroot/js/app/module.js